// import React, { useState, useEffect, useRef } from 'react';
// import { FaSearch } from 'react-icons/fa';
// import './App.css';

// function App() {
//   const [youtubeLink, setYoutubeLink] = useState('');

//   // Create a reference for the input field
//   const searchInputRef = useRef(null);

//   useEffect(() => {
//     // Focus on the search input when the component is mounted
//     if (searchInputRef.current) {
//       searchInputRef.current.focus();
//     }
//   }, []); // Empty dependency array ensures this runs only once after mount


//   const handleAnalyze = () => {
//     if (youtubeLink) {
//       console.log("Analyzing:", youtubeLink);
//     }
//     else {
//       console.log("not a valid")
//     }
//   };

//   const handleLogin = () => {
//     // Handle login functionality here
//     console.log("Login button clicked");
//   };

//   return (
//     <div> 
//       <header className='header'>
//         <button onClick={handleLogin} className="login-btn">Login</button>
//       </header>
//       <div className="search-container">
//         <h1 className="logo">CommentInsight</h1>
//         <div className="search-bar">
//           <FaSearch className="search-icon" />
//           <input 
//             type="text" 
//             placeholder="Paste YouTube link here..." 
//             value={youtubeLink}
//             onChange={(e) => setYoutubeLink(e.target.value)}
//             ref={searchInputRef} // Link the input field to the ref
//           />
//         <button onClick={handleAnalyze} className="analyze-btn">Analyze</button>
//         </div>
//       </div>
//     </div>
//   );
  
// }

// export default App;





import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import Account from './components/Account';
import History from './pages/History';
import PageNotFound from './pages/PageNotFound';
import GoogleLogin from './pages/GoogleLogin';
import VideoDetails from './pages/VideoDetails';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/verify';
import AboutUs from './pages/AboutUs';
import FeaturesBenefits from './pages/FeaturesBenefits';
import FeaturesBenefitsecond from './pages/FeaturesBenefitsecond';
import YouTubeThumbnailDownloaderPage from './pages/Youtube-Thumbnail-Download';
import RequestAccess from './pages/RequestAccess';


// import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const GoogleAuthWrapper = () =>{
    return (
      <GoogleOAuthProvider clientId = '253484160473-oplip4bk33e59qljlpbs8rs3dir55dvp.apps.googleusercontent.com'>
        <GoogleLogin></GoogleLogin>
      </GoogleOAuthProvider>
    )
  }
  const GoogleAuthWrapper1 = () =>{
    return (
      <GoogleOAuthProvider clientId = '253484160473-oplip4bk33e59qljlpbs8rs3dir55dvp.apps.googleusercontent.com'>
        <LoginPage></LoginPage>
      </GoogleOAuthProvider>
    )
  }

  const GoogleAuthWrapper2 = () =>{
    return (
      <GoogleOAuthProvider clientId = '253484160473-oplip4bk33e59qljlpbs8rs3dir55dvp.apps.googleusercontent.com'>
        <SignUpPage></SignUpPage>
      </GoogleOAuthProvider>
    )
  }

  
  // const PrivateRoute = ({element})=>{
  //   return isAuthenticated ? element : <Navigate to = "/"/>;
  // }

  return (
    <HelmetProvider>

    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        {/* <Route path="/login" element={<PrivateRoute element={<LoginPage/>}/>}/> */}
        {/* <Route path="/login" element={<LoginPage/>}/> */}
        {/* <Route path="/signup" element={<SignUpPage/>} /> */}
        <Route path="/account" element={<Account/>} />
        <Route path="/history" element={<History/>} />
        <Route path="/history/video/:id" element={<VideoDetails />} />
        <Route path="/*" element={<PageNotFound/>} />
        <Route path="/google-login" element={<GoogleAuthWrapper/>} />
        <Route path="/login" element={<GoogleAuthWrapper1/>} />
        <Route path="/signup" element={<GoogleAuthWrapper2/>} />
        <Route path="/forget-password" element={<ForgetPassword/>} />
        <Route path="/reset-password" element={<ResetPassword/>} />
        <Route path="/verify" element={<VerifyEmail/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="/features" element={<FeaturesBenefits/>} />
        <Route path="/featuresecond" element={<FeaturesBenefitsecond/>} />
        <Route path="/youtube-thumbnail-download" element={<YouTubeThumbnailDownloaderPage/>} />
        <Route path="/request-access" element={<RequestAccess/>} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;